import React from 'react';
import { useLanguage } from '../context/LanguageProvider';
import { motion } from 'framer-motion';

export const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative py-12 bg-vilarias-black border-t border-vilarias-border">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-vilarias-accent/30 to-transparent" />

      <div className="section-padding">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6"
        >
          <div className="text-center md:text-left">
            <p className="font-serif text-2xl text-white tracking-wider mb-1">{t.footer.brand}</p>
            <p className="text-sm text-vilarias-text-secondary">{t.footer.tagline}</p>
          </div>

          <div className="flex items-center gap-2 text-vilarias-text-secondary text-sm">
            <span className="w-2 h-2 rounded-full bg-vilarias-accent animate-pulse" />
            {t.footer.location}
          </div>

          <div className="text-center md:text-right">
            <p className="text-xs text-vilarias-text-secondary">
              © {new Date().getFullYear()} Vilarias. All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};
